import { render, staticRenderFns } from "./Carusel.vue?vue&type=template&id=d04a1cee"
import script from "./Carusel.vue?vue&type=script&lang=js"
export * from "./Carusel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports